import React from "react";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem, treeItemClasses } from "@mui/x-tree-view/TreeItem";
import { Typography, Box } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import List from "@mui/material/List";
import ListItem, { listItemClasses } from "@mui/material/ListItem";
import MzTooltip from "@markaaz/ui/MzTooltip";

const sx = {
  treeItem: {
    svg: {
      color: "blue.c100",
      width: "24px",
      height: "24px"
    },
    [`& .${treeItemClasses.content}`]: {
      paddingLeft: "40px"
    },
    [`.${treeItemClasses.content}.Mui-selected`]: {
      backgroundColor: "blue.c5"
    },
    [`.${treeItemClasses.content}.Mui-focused`]: {
      backgroundColor: "blue.c5"
    },
    [`.${treeItemClasses.content}.Mui-selected.Mui-focused`]: {
      backgroundColor: "blue.c5"
    },
    [`.${treeItemClasses.content}`]: {
      minHeight: "30px",
      maxHeight: "100px",
      "&:hover": {
        backgroundColor: "blue.c5"
      }
    },
    ".MuiSvgIcon-root": {
      paddingLeft: "8px"
    }
  },
  label: {
    cursor: "text"
  },
  tooltip: {
    "& .MuiTooltip-tooltip": {
      maxWidth: "471px"
    }
  },
  labelWrap: {
    display: "flex",
    alignItems: "center"
  },
  list: {
    listStyleType: "disc",
    margin: "16px 20px",
    padding: 0,
    [`.${listItemClasses.root}`]: {
      display: "list-item",
      padding: 0
    }
  }
};

export default function MarkaazMatchFoundDetails({ data, matchFoundTooltipData }) {
  if (data == null) return null;

  function renderTree(data, parentIndex = "") {
    return Object.entries(data).map(([key, value], outerIndex) => {
      if (key.startsWith("_") || value === undefined || key === "Address Type:") return null;

      let labelValue = "";

      if (Array.isArray(value)) {
        labelValue = `${key} (${value?.length})`;
      } else if (typeof value === "object" && value !== null) {
        labelValue = value._label || key;
      } else {
        labelValue = `${key} ${value}`;
      }

      return (
        <TreeItem
          sx={sx.treeItem}
          itemId={`${parentIndex}-${outerIndex}`}
          label={
            <Box sx={sx.labelWrap}>
              <Typography sx={sx.label} variant="body2">
                {labelValue}
              </Typography>
              {matchFoundTooltipData != null && key in matchFoundTooltipData && (
                <MzTooltip
                  sx={sx.tooltip}
                  title={
                    Array.isArray(matchFoundTooltipData[key]) ? (
                      <List sx={sx.list}>
                        {matchFoundTooltipData[key].map((value, index) => (
                          <ListItem key={index}>{value}</ListItem>
                        ))}
                      </List>
                    ) : (
                      matchFoundTooltipData[key]
                    )
                  }
                  arrow
                  placement="top"
                  PopperProps={{
                    modifiers: [{ name: "preventOverflow", options: { padding: 20 } }]
                  }}
                >
                  <InfoOutlinedIcon></InfoOutlinedIcon>
                </MzTooltip>
              )}
            </Box>
          }
        >
          {value === null
            ? null
            : Array.isArray(value)
            ? value.map((item, index) => {
                return (
                  <TreeItem
                    sx={sx.treeItem}
                    itemId={`${parentIndex}${outerIndex}${index}`}
                    label={<Typography sx={sx.label} variant="body2">{`${item["_label"]}`}</Typography>}
                  >
                    {renderTree(item, `${parentIndex}-${outerIndex}-${index}`)}
                  </TreeItem>
                );
              })
            : typeof value === "object"
            ? renderTree(value, `${parentIndex}${outerIndex}`)
            : null}
        </TreeItem>
      );
    });
  }

  return <SimpleTreeView>{renderTree(data)}</SimpleTreeView>;
}
